// extracted by mini-css-extract-plugin
export default {"content_position":"ListUser_content_position__MBuMc","form":"ListUser_form__NTXXL","popup_wrap":"ListUser_popup_wrap__v1brj","content_popup":"ListUser_content_popup__sPBiD"};